import * as React from 'react';
import './EstimationsToolbar.css';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { connect } from 'react-redux';
import State from '../../application/core/State';
import EstimationProductsSearchRequested from '../../application/estimations/events/EstimationProductsSearchRequested';
import Search from '../search/Search';

interface StateProps {
    querySearch: string;
}

class EstimationsToolbar extends React.PureComponent<DispatchProps & StateProps> {
    public render(): JSX.Element {
        return (
            <div className="estimations-toolbar">
                <div className="estimations-toolbar-container">
                    <div className="search">
                        <Search onSearch={this.onSearch} value={this.props.querySearch} />
                    </div>
                </div>
            </div>
        );
    }

    private onSearch = (value: string): void => {
        this.props.dispatch(new EstimationProductsSearchRequested(value));
    };
}

const mapStateToProps = (state: State): StateProps => ({
    querySearch: state.estimations.searchQuery
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EstimationsToolbar);



// WEBPACK FOOTER //
// ./src/view/estimations/EstimationsToolbar.tsx